import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class OutsideClickHandler extends Component {
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = event => {
        const { closeDropDown } = this.props;

        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            closeDropDown();
        }
    };

    render() {
        return (
            <div
                ref={wrapperRef => {
                    this.wrapperRef = wrapperRef;
                    return null;
                }}
            >
                {this.props.children}
            </div>
        );
    }
}

OutsideClickHandler.propTypes = {
    closeDropDown: PropTypes.func.isRequired,
};
